<template>
    <van-popup
        v-if="workOrderAssignPopupShow"
        :value="workOrderAssignPopupShow"
        z-index="100"
        :close-on-click-overlay="false"
        :style="{ height: '100vh', width: '100vw', background: 'rgba(0,0,0,.3)' }"
        overlay-class="custom_popup"
        position="right"
    >
        <div class="public_container add_approval_wrap">
            <div class="returnNavBar">
                <ReturnNavBar
                    :isCustomReturnEvent="true"
                    :isTitleNormal="true"
                    :isAllFunctions="true"
                    title="返回"
                    @returnEvent="handleClickClose"
                ></ReturnNavBar>
            </div>
            <div class="work_order_add_container mobile_container custom_mobile_form" v-loading="loading">
                <van-form
                    label-width="9.5em"
                    input-align="right"
                    scroll-to-error
                    :show-error-message="false"
                    :rules="workOrderAssignFormRules"
                    ref="workOrderAssignForm"
                    class=""
                >
                    <div
                        v-for="(user, index) in workOrderAssignForm.processing_user"
                        :key="index"
                        class="work_assign_user_item"
                    >
                        <div class="work_assign_user_item_title">
                            <span>实施明细</span>
                            <span
                                class="handle_icon_wrap"
                                v-show="workOrderAssignForm.processing_user.length > 1"
                                @click="handleClickRemoveUser(index)"
                                ><i class="iconfont icon-shanchu1"></i
                            ></span>
                        </div>
                        <div class="work_assign_user_item_content">
                            <van-field
                                :required="true"
                                v-model="user.processing_uids_text"
                                :name="`processing_user.${index}.processing_uids`"
                                label="分配实施人员"
                                placeholder="请选择"
                                :rules="workOrderAssignFormRules.processing_uids"
                                error-message-align="right"
                                is-link
                                readonly
                                @click="handleClickProcessingUidsFieldlink(user, index)"
                            >
                            </van-field>
                            <van-field
                                :required="true"
                                v-model="user.plan_start_date_text"
                                :name="`processing_user.${index}.plan_start_date`"
                                label="实施开始时间"
                                placeholder="请选择"
                                :rules="workOrderAssignFormRules.plan_start_date"
                                error-message-align="right"
                                is-link
                                readonly
                                @click="handleClickDateFieldlink('plan_start_date', index)"
                            >
                            </van-field>
                            <van-field
                                :required="true"
                                v-model="user.plan_end_date_text"
                                :name="`processing_user.${index}.plan_end_date`"
                                label="实施结束时间"
                                placeholder="请选择"
                                :rules="validateEndDate(user)"
                                error-message-align="right"
                                is-link
                                readonly
                                @click="handleClickDateFieldlink('plan_end_date', index)"
                            >
                            </van-field>
                        </div>
                    </div>
                    <div class="work_assign_item_add" @click="handleClickAddUser">
                        <i class="iconfont icon-tianjia1"></i>
                        <span>添加更多</span>
                    </div>
                    <van-field
                        v-model="workOrderAssignForm.assign_note"
                        name="assign_note"
                        label="说明"
                        placeholder="请输入"
                        error-message-align="right"
                        type="textarea"
                        :rows="5"
                        maxlength="500"
                        input-align="left"
                        class="vertical_input_wrap"
                    >
                    </van-field>
                </van-form>
            </div>
            <div class="add_footer_wrap mobile_add_footer_wrap">
                <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm"
                    >确定</van-button
                >
            </div>
            <!-- 实施人员选择 -->
            <UserSelect
                :userSelectVisible.sync="userSelectVisible"
                :userSelectTitle="'选择实施人员'"
                :allUserList="getProcessingUserList()"
                :selectType="'multiple'"
                @selectUserData="handleSelectUserData"
                v-if="userSelectVisible"
            />
            <!--_年_月_日 日期选择-->
            <van-calendar
                v-model="showDateCalendar"
                color="#2990FF"
                :min-date="dateCalendarMin"
                :max-date="dateCalendarMax"
                @confirm="handleDateCalenderConfirm"
            />

            <van-overlay
                :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
                z-index="1000"
                v-if="handleRadioPicker"
                :show="handleRadioPicker"
                @click="handleRadioPicker = false"
            >
                <div class="custome_radio_option_wrap">
                    <ul class="radio_option_list">
                        <li
                            class="radio_option_item"
                            v-for="item in radioOptions"
                            :key="item.value"
                            @click="handleClickOption(item)"
                        >
                            {{ item.label }}
                        </li>
                        <div class="cancel_btn" @click="handleClickRadioCancel">取消</div>
                    </ul>
                </div>
            </van-overlay>
        </div>
    </van-popup>
</template>
<script>
import { roleDetail, workOrderAssign } from "@/api";
import { formatDate } from "@/utils";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import UserSelect from "./component/user_select.vue";
export default {
    name: "WorkOrderAssign",
    components: { ReturnNavBar, UserSelect },
    props: {
        workOrderAssignPopupShow: {
            type: Boolean,
            default: false,
        },
        workorder_id: "",
        processing_users_selected_ids: {
            type: Array,
            default: () => []
        }
    },
    data() {
        // 自定义校验规则：结束时间不能早于开始时间
        const validateStartDate = (item) => [
            { required: true, message: "请选择时间", trigger: ["blur", "change"] },
            {
                validator: (value) => {
                    if (!item.plan_start_date || !item.plan_end_date) return true;
                    return new Date(item.plan_end_date) >= new Date(item.plan_start_date);
                },
                message: '实施结束时间不能晚于实施开始时间'
            }
        ]
        const validateEndDate = (item) => [
            { required: true, message: "请选择时间", trigger: ["blur", "change"] },
            {
                validator: (value) => {
                    if (!item.plan_start_date || !item.plan_end_date) return true;
                    return new Date(item.plan_end_date) >= new Date(item.plan_start_date);
                },
                message: '实施结束时间不能早于实施开始时间'
            }
        ]
        return {
            loading: false,
            workOrderAssignForm: {
                processing_user: [
                    {
                        processing_uids: "",
                        processing_uids_text: "",
                        plan_start_date: "",
                        plan_start_date_text: "",
                        plan_start_time: 1,
                        plan_end_date: "",
                        plan_end_date_text: "",
                        plan_end_time: 1,
                    },
                ],
                assign_note: "",
            },
            workOrderAssignFormRules: {
                processing_uids: [{ required: true, message: "请选择", trigger: ["blur", "change"] }],
                plan_start_date: [{ required: true, message: "请选择时间", trigger: ["blur", "change"] }],
                plan_end_date: [{ required: true, message: "请选择时间", trigger: ["blur", "change"] }],
            },
            validateStartDate,
            validateEndDate,
            processingUserList: [], // 可选择的实施人员
            btnDisabled: false,

            nowFieldFormData: "",
            currentField: "", // 当前选择的key
            currentSelectIndex: 0, // 当前选择项索引
            userSelectVisible: false,

            showDateCalendar: false,
            dateCalendarMin: new Date("2015-01-01"),
            dateCalendarMax: new Date("2070-01-01"),

            handleRadioPicker: false,
            radioOptions: [
                { label: "上午", value: 1 },
                { label: "下午", value: 2 },
            ],
        };
    },
    created() {
        this.getRoleDetail();
    },
    methods: {
        handleClickClose() {
            this.$emit("update:workOrderAssignPopupShow", false)
        },
        // 获取可分配的实施人员，每个人员只能选择一次
        getProcessingUserList() {
            const users = this.processingUserList || []
            const uids = this.workOrderAssignForm.processing_user.map(item=> item.processing_uids).flat()
            const list = users.filter(item=> !uids.includes(item.id))
            return list
        },
        // 添加
        handleClickAddUser() {
            this.workOrderAssignForm.processing_user.push({
                processing_uids: "",
                processing_uids_text: "",
                plan_start_date: "",
                plan_start_date_text: "",
                plan_start_time: 1,
                plan_end_date: "",
                plan_end_date_text: "",
                plan_end_time: 1,
            });
            this.$nextTick(() => {
                this.$refs.workOrderAssignForm.resetValidation();
            });
        },
        // 删除
        handleClickRemoveUser(index) {
            // if (this.workOrderAssignForm.processing_uids.length > 1) {
            //     this.workOrderAssignForm.processing_uids.splice(index, 1);
            // }
            this.workOrderAssignForm.processing_user.splice(index, 1);
        },
        // 选择实施人员
        handleClickProcessingUidsFieldlink(user, index) {
            this.nowFieldFormData = user;
            this.userSelectVisible = true;
            this.currentSelectIndex = index;
        },
        // 选择实施人员确认
        handleSelectUserData(data) {
            let user = this.workOrderAssignForm.processing_user[this.currentSelectIndex];
            user.processing_uids = data.map((item) => item.id);
            user.processing_uids_text = data.map((item) => item.name).join();
            this.workOrderAssignForm.processing_user[this.currentSelectIndex] = user;
            this.$forceUpdate();
        },
        // 时间选择
        handleClickDateFieldlink(currentField, index) {
            this.currentField = currentField;
            this.currentSelectIndex = index;
            this.showDateCalendar = true;
        },
        //点击日期选择器确定事件
        handleDateCalenderConfirm(date) {
            this.currentDate = date;
            this.showDateCalendar = false;
            this.handleRadioPicker = true;
        },
        // 选择时间段确认
        handleClickOption(item) {
            this.$set(
                this.workOrderAssignForm.processing_user[this.currentSelectIndex],
                this.currentField,
                formatDate(this.currentDate, "date")
            );
            if (this.currentField === "plan_start_date") {
                this.$set(
                    this.workOrderAssignForm.processing_user[this.currentSelectIndex],
                    "plan_start_time",
                    item.value
                );
                const date_txt =
                    this.workOrderAssignForm.processing_user[this.currentSelectIndex].plan_start_date +
                    "-" +
                    item.label;
                this.$set(
                    this.workOrderAssignForm.processing_user[this.currentSelectIndex],
                    "plan_start_date_text",
                    date_txt
                );
            } else {
                this.$set(
                    this.workOrderAssignForm.processing_user[this.currentSelectIndex],
                    "plan_end_time",
                    item.value
                );
                const date_txt =
                    this.workOrderAssignForm.processing_user[this.currentSelectIndex].plan_end_date + "-" + item.label;
                this.$set(
                    this.workOrderAssignForm.processing_user[this.currentSelectIndex],
                    "plan_end_date_text",
                    date_txt
                );
            }
            this.handleRadioPicker = false;
        },
        // 选择取消
        handleClickRadioCancel() {
            this.currentSelectIndex = -1;
            this.currentField = "";
            this.currentDate = null;
            this.handleRadioPicker = false;
        },
        // 获取在工单实施角色中设置的范围内选择人员
        getRoleDetail() {
            roleDetail({
                role_type: "processing_user",
            }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || [];
                    const selectedUids = JSON.parse(JSON.stringify(this.processing_users_selected_ids));
                    // 从实施角色中的全部未被选择人员中选择，排除掉当前工单已经选择过的
                    const processingUserList = data.filter((item) => !selectedUids.includes(item.id));
                    this.processingUserList = processingUserList;
                }
            });
        },
        handleClickConfirm() {
            this.$refs.workOrderAssignForm.validate().then(() => {
                if (!this.workorder_id) return;
                let processing_user = JSON.parse(JSON.stringify(this.workOrderAssignForm.processing_user));
                processing_user = processing_user.map((item) => {
                    delete item.processing_uids_text;
                    delete item.plan_start_date_text;
                    delete item.plan_end_date_text;
                    return item;
                });
                const params = {
                    workorder_id: this.workorder_id,
                    processing_user,
                    assign_note: this.workOrderAssignForm.assign_note,
                };
                this.btnDisabled = true;
                workOrderAssign(params)
                    .then((res) => {
                        if (res.code === 200) {
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.btnDisabled = false;
                                    this.$emit("update:workOrderAssignPopupShow", false)
                                    this.$emit("AssignSuccess")
                                },
                            });
                        } else {
                            this.btnDisabled = false;
                        }
                    })
                    .catch(() => {
                        this.btnDisabled = false;
                    });
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.mobile_container {
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;
    .work_assign_user_item {
        .work_assign_user_item_title {
            position: relative;
            height: 44px;
            padding: 0 16px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: #fff;

            font-size: 14px;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(51, 51, 51, 1);
            span {
                font-weight: 700;
            }
            i {
                color: rgba(102, 102, 102, 1);
                font-weight: 400;
            }
            &::after {
                position: absolute;
                box-sizing: border-box;
                content: " ";
                pointer-events: none;
                right: 0;
                bottom: 0;
                left: 0;
                border-bottom: 1px solid #ebedf0;
                -webkit-transform: scaleY(0.5);
                transform: scaleY(0.5);
            }
        }
    }
    .work_assign_item_add {
        position: relative;
        width: 100%;
        height: 44px;
        background-color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(41, 144, 255, 1);
        i {
            margin-right: 8px;
        }
        &::before {
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            top: 0;
            left: 0;
            border-top: 1px solid #ebedf0;
            -webkit-transform: scaleY(0.5);
            transform: scaleY(0.5);
        }
        &::after {
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            bottom: 0;
            left: 0;
            border-bottom: 1px solid #ebedf0;
            -webkit-transform: scaleY(0.5);
            transform: scaleY(0.5);
        }
    }
}
</style>
